"use client";

import { ChevronLeft, ChevronRight } from "lucide-react";
import { cn } from "@/lib/utils";

// Floating edge arrow for horizontal media rails. Reveal-on-hover is driven by
// the parent's group class, passed via `groupHoverClass` so each section keeps
// its own group namespace (e.g. "group-hover/ads:opacity-100").
export function RailArrow({
  dir,
  visible,
  terminal,
  onClick,
  groupHoverClass,
}: {
  dir: "left" | "right";
  visible: boolean;
  terminal: boolean;
  onClick: () => void;
  groupHoverClass: string;
}) {
  const Icon = dir === "left" ? ChevronLeft : ChevronRight;
  return (
    <button
      type="button"
      aria-label={dir === "left" ? "Scroll left" : "Scroll right"}
      tabIndex={visible ? 0 : -1}
      onClick={onClick}
      className={cn(
        "absolute top-1/2 -translate-y-1/2 z-20 grid place-items-center h-10 w-10 rounded-full",
        "border backdrop-blur-md shadow-lg transition-all duration-200",
        "opacity-0 focus-visible:opacity-100",
        groupHoverClass,
        dir === "left" ? "left-1" : "right-1",
        visible ? "pointer-events-auto" : "pointer-events-none !opacity-0",
        terminal
          ? "bg-black/80 border-emerald-500/50 text-emerald-300 hover:bg-emerald-500/20"
          : "bg-background/85 border-border text-foreground hover:bg-background"
      )}
    >
      <Icon className="h-5 w-5" />
    </button>
  );
}
